<style scoped>
  .modal-card {
    width: 265px;
  }
</style>

<template>
  <section class="container modal-card" :class="{'is-loading': loadingForm}">
    <portal-box>
      <h1 slot="titulo" class="title">Alterar Senha</h1>

      <b-field label="Nova Senha"
               :type="$errorType('senha', errors)"
               :message="errors.first('senha')">
        <b-input v-model="objeto.novaSenha" name="senha" type="password" password-reveal
                 data-vv-as="Nova Senha" v-validate="'min:6|max:10'"/>
      </b-field>

      <footer class="has-text-right">
        <button type="button" class="button" @click="$parent.close()" :class="{'is-loading': loadingForm}">Cancelar</button>
        <button class="button is-primary" :class="{'is-loading': loadingForm}"
                @click="alterarSenha">
          <b-icon icon="check"></b-icon>
          <span>Salvar</span>
        </button>
      </footer>
    </portal-box>
  </section>
</template>

<script>
  export default {
    props: ['urlTrocaSenha'],
    data () {
      return {
        objeto: {novaSenha: null},
        loadingForm: false
      }
    },
    methods: {
      alterarSenha () {
        this.loadingForm = true
        this.$http.put(this.urlTrocaSenha, this.objeto, this.$header())
          .then(res => {
            this.$toast.open({
              message: 'Senha alterada com sucesso!',
              type: 'is-success',
              duration: 7 * 1000
            })
            this.$parent.close()
          }, res => {
            this.loadingForm = false
            this.$toast.open({
              message: 'Não foi possível alterar a senha.',
              type: 'is-danger',
              duration: 7 * 1000
            })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ModalAlterarSenha.vue